module.exports = __webpack_public_path__ + "static/media/portfolioUsingDjango.95dd3e00.webp";